import modelBaseV2 from '../model-base-v2.model';

let teamApprovalModel = {

  getStatusList: function () {
    return modelBaseV2.get('/api/codemaster/ScheduleApprovalType');
  },

  getPendingApprovals: function (filter) {
    let urlParams = modelBaseV2.toQueryString({
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      ScheduleApprovalType: filter.status,
      WorkType: filter.workType.join('^'),
      UserIds: filter.selectedUsers.map(u => u.userID).join('^'),
      PageIndex: filter.pageIndex,
      PageSize: filter.pageSize
    });
    return modelBaseV2.get('/api/schedule/pendingApproval?' + urlParams);
  },

  changeStatusList: function (status, idList) {
    let params = { action: status, scheduleApprovalIDList: idList };
    return modelBaseV2.post('/api/schedule/approve', { body: params });
  },

  changeStatus: function (status, filter, remarks, startTime, endTime) {
    let params = {
      approvalType: "002",
      scheduleID: filter.scheduleApprovalID,
      action: status,
      workType: filter.workType,
      siteId: filter.siteId,
      scheduleDate: filter.scheduleDate,
      breakHour: filter.breakHour,
      remarks: filter.remarks,
      supervisorRemarks: remarks,
      startTime: startTime,
      endTime: endTime
    };
    return modelBaseV2.post('/api/schedule/edit/' + filter.scheduleApprovalID, { body: params });
  },

  downloadExcel: (request, fileName) => {
    let params = {
      sortBy: "",
      orderBy: "",
      pageIndex: 0,
      pageSize: 0,
      storedProcedureCode: "11",
      excelSheetNames: ["Visit Plan List", "Visit Plan Count"],
      params: [
        { code: "8", value: request.fromDate },
        { code: "9", value: request.toDate },
        { code: "30", value: request.selectedSiteGroupListArr.join('^') },
        { code: "31", value: request.selectedSiteListArr.join('^') },
        { code: "32", value: request.selectedUserListArr.join('^') },
        { code: "33", value: request.planStatus },
        { code: "24", value: "" },
        { code: "2", value: "" },
        { code: "3", value: "0" },
        { code: "4", value: "0" }
      ]
    };
    let path = '/api/executesp/export/tr/file';
    return modelBaseV2.postDownload(path, { body: params }, fileName + ".xlsx");
  }

}

export default teamApprovalModel;
